import CustomTooltip from "../../../../../components/CustomTooltip";
import {EMPTY_VALUES} from "../../../../../Apis/functions";
/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 12 de 05 de 2026
 */
export const AccessInfoItem = ({
                            icon: Icon,
                            subIcon: SubIcon,
                            label,
                            value,
                            valueClassName = 'font-color-shades-500 fs-14px text-ellipsis-1-row',
                            className = '',
                            iconClassName = '',
                            subIconClassName = '',
                        }) => {

    return (
        <div className={`d-flex flex-column minw-0 px-2 ${className}`}>

            <div className="d-flex gap-2 align-items-center">
                {Icon && (
                    <Icon
                        width={16}
                        height={16}
                        className={`flex-shrink-0 mb-2px ${iconClassName}`}
                    />
                )}

                <div className="flex-grow-1 minw-0">
                    <CustomTooltip
                        text={label}
                        classes="fs-14px ibl-font-w-600 text-ellipsis-1-row"
                        showIfTruncated
                        placement="top"
                    />
                </div>
            </div>

            <div className="d-flex gap-2 align-items-center">
                {SubIcon && (
                    <SubIcon
                        width={16}
                        height={16}
                        className={`flex-shrink-0 mb-2px ${subIconClassName}`}
                    />
                )}

                <div className="flex-grow-1 minw-0">
                    <CustomTooltip
                        text={value || EMPTY_VALUES.DEFAULT}
                        classes={valueClassName}
                        showIfTruncated
                        placement="top"
                    />
                </div>
            </div>

        </div>
    );
};

export default AccessInfoItem;
